class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.innerHTML = `
            <style>
                .progress-container {
                    width: 100%;
                    background-color: #f5debd;
                    overflow: hidden;
                    border-bottom: solid 1px;
                }
                .progress-bar {
                    height: 20px;
                    background-color: #d4bc9a;
                    width: 0%;
                    transition: width 1s ease-in-out;
                    background-image: linear-gradient(
                        45deg,
                        rgba(255, 255, 255, 0.15) 25%,
                        transparent 25%,
                        transparent 50%,
                        rgba(255, 255, 255, 0.15) 50%,
                        rgba(255, 255, 255, 0.15) 75%,
                        transparent 75%,
                        transparent
                    );
                    background-size: 40px 40px; /* Size of the stripes */
                    animation: move-stripes 2s linear infinite; /* Animation */
                }
                .remaining-text {
                    font-size: 11px;
                    color: #333;
                    position: absolute;
                    top: 1px;
                    right: 20px;
                    font-style: italic;
                }
                @keyframes move-stripes {
                    from {
                        background-position: 0 0;
                    }
                    to {
                        background-position: 40px 0;
                    }
                }
            </style>
            <div class="progress-container">
                <div class="progress-bar"></div>
                <div class="remaining-text"></div>
            </div>
        `;
  }

  static get observedAttributes() {
    return ["value", "max", "remaining"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "value" || name === "remaining") {
      this.updateProgress();
    }
    if (name === "remaining") {
      this.updateRemaining();
    }
  }

  connectedCallback() {
    this.shadowRoot.querySelector(".progress-bar").style.width = "0%";

    setTimeout(() => {
      this.updateProgress();
      this.updateRemaining();
    }, 500);
  }

  updateProgress() {
    const value = parseInt(this.getAttribute("value"), 10) || 0;
    const max = parseInt(this.getAttribute("max"), 100) || 100;
    const percent = (value / max) * 100;

    this.shadowRoot.querySelector(".progress-bar").style.width = `${percent}%`;
  }

  updateRemaining() {
    const remaining = parseFloat(this.getAttribute("remaining")) || 0;
    const remaining_text = this.getAttribute("remaining_text") || "Encore";
    const remaining_text2 = this.getAttribute("remaining_text-2") || "€ !";
    this.shadowRoot.querySelector(
      ".remaining-text"
    ).textContent = `${remaining_text} ${remaining.toFixed(
      2
    )}${remaining_text2}`;
  }
}

window.customElements.define("progress-bar", ProgressBar);
